const TempMonitorDraft = (props) => {
  return (
    <div>
      <img src="/images/sian.png" alt="로그아웃" />
    </div>
  );
};

export default TempMonitorDraft;
